module.exports = __webpack_public_path__ + "img/nav-louti.fbd7d86b.png";